// extracted by mini-css-extract-plugin
export default {"card":"ResearchCard_card__xjqFd","cardDescriptionContainer":"ResearchCard_cardDescriptionContainer__OqUyL"};